var specific_location = "";
var delivery_grp = "";
var enable_zip_validate = true;
var add_postalcode;
var index_one;
var index_two;
var enable_option = "true";
var method_type = "delivery";
var geocoder;
var map;
var mapPostCode = "";
var special_collection_date = special_collection_dates;
var ProductSKU = productSKU;
var productSKUs = "";

$(document).ready(function () {
  update_empty_pickup();

  // show_storepickups();

  if (ProductSKU) {
    var productSKUs = ProductSKU.split(",");
  }

  jQuery('.shipping_option input[name="attributes[Type]"]').on(
    "click",
    function () {
      console.log($(this).val());
      if ($('input[name="attributes[Type]"]:checked').val() == "pickup") {
        //show_storepickups();
        //jQuery(".location_single").show();
      } else if (
        $('input[name="attributes[Type]"]:checked').val() == "delivery"
      ) {
        $(".roses_shipping input:radio").attr("checked", false);
        update_empty_pickup();
        method_type = "delivery";
      }
    }
  );

  jQuery('.roses_shipping .roses_ship_method input[name="method_pickup"]').on(
    "click",
    function () {
      if ($('.roses_shipping input[name="method_pickup"]:checked').val()) {
        var location_detail = $(
          '.roses_shipping input[name="method_pickup"]:checked'
        ).val();
        $(".delivers input:radio").attr("checked", false);
        $('.storepickups input[name="attributes[Type]"]').prop("checked", true);
        method_type = "pickup";
        specific_location = location_detail;
        update_pickup(location_detail);
      }
    }
  );

  jQuery(".zero_step [name=checkout_zero]").on("click", function (e) {
    e.preventDefault();
    if ($("input[name='attributes[Type]']:checked").val()) {
      console.log($("input[name='attributes[Type]']:checked").val());
      if ($("input[name='attributes[Type]']:checked").val() == "pickup") {
        if (!$("input[name='method_pickup']:checked").val()) {
          jQuery(".shipping_option .error_method").html(
            "<p>Please select the Location</p>"
          );
        } else {
          jQuery(".tab_based_content").show();
          $(
            "section.recipentField .hideonpickup input[name='attributes[Delivery-Address-of-Recipient]']"
          ).val("");
          $(
            "section.recipentField .hideonpickup textarea[name='attributes[Special-Instruction-for-Courier]']"
          ).val("");
          jQuery("section.recipentField .hideonpickup").hide();
          jQuery("html, body").animate(
            {
              scrollTop: jQuery(".steps"),
            },
            0
          );

          jQuery(
            "form .section-header, form .cart-item, form .checkout-update, form .shipping_option, form .zero_step, form .checkout-options, form .cart-page .product-cart"
          ).addClass("hideOnPopup");
        }
      } else if (
        $("input[name='attributes[Type]']:checked").val() == "delivery"
      ) {
        jQuery(".tab_based_content").show();
        jQuery("html, body").animate(
          {
            scrollTop: jQuery(".steps"),
          },
          0
        );
        jQuery(
          "form .section-header, form .cart-item, form .checkout-update, form .shipping_option, form .zero_step, form .checkout-options, form .cart-page .product-cart"
        ).addClass("hideOnPopup");
      }
    } else {
      jQuery(".shipping_option .error_method").html(
        "<p>Please select the Delivery Option</p>"
      );
    }
  });

  // $("#cart_tabs select#ocassion").on("change", function () {
  //   jQuery("#cart_tabs section div.error_ocassion").html("");
  // });
  // $("#cart_tabs select#locationmsg").on("change", function () {
  //   jQuery("#cart_tabs section div.error_locationmsg").html("");
  // });
  // $("#cart_tabs #gift_message").on("input", function () {
  //   jQuery("#cart_tabs section div.error_gift").html("");
  // });

  $("form.cart")
    .find("input")
    .keypress(function (e) {
      if (e.which == 13) {
        // Enter key = keycode 13
        $(this).next().focus(); //Use whatever selector necessary to focus the 'next' input
        return false;
      }
    });
}); // end of document.ready

function noWeekendsOrHolidays(
  date,
  method_type,
  specific_location,
  numberofspecialproduct,
  special_collection_date
) {
  var day = date.getDay();
  var weekday = [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ];
  var weekdeliveryday = [
    "sunday_disable",
    "monday_disable",
    "tuesday_disable",
    "wednesday_disable",
    "thursday_disable",
    "friday_disable",
    "saturday_disable",
  ];

  if (method_type) {
    if (method_type == "pickup") {
      var obj = ebzapiets;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );
      var days_list = selected_location.days;

      var black_week = [];
      for (var i in weekday) {
        var info_day = weekday[i];
        if (days_list[info_day]) {
          if (days_list[info_day].disable) {
            ii = parseInt(i);
            black_week.push(ii);
          }
        }
      }

      if (black_week) {
        if (jQuery.inArray(day, black_week) >= 0) {
          return [false];
        } else {
          if (
            nationalDays(
              date,
              method_type,
              specific_location,
              numberofspecialproduct,
              special_collection_date
            )
          ) {
            return [true];
          } else {
            return [false];
          }
        }
      } else {
        if (
          nationalDays(
            date,
            method_type,
            specific_location,
            numberofspecialproduct,
            special_collection_date
          )
        ) {
          return [true];
        } else {
          return [false];
        }
      }
      //end
    } else if ((method_name = "delivery")) {
      var obj = ebzapiets_delivery;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );
      var days_list = selected_location.slot;

      var black_week = [];
      for (var i in weekdeliveryday) {
        var info_day = weekdeliveryday[i];
        if (days_list[info_day] == 1) {
          ii = parseInt(i);
          black_week.push(ii);
        }
      }

      if (black_week) {
        if (jQuery.inArray(day, black_week) >= 0) {
          return [false];
        } else {
          if (
            nationalDays(
              date,
              method_type,
              specific_location,
              numberofspecialproduct,
              special_collection_date
            )
          ) {
            return [true];
          } else {
            return [false];
          }
        }
      } else {
        if (
          nationalDays(
            date,
            method_type,
            specific_location,
            numberofspecialproduct,
            special_collection_date
          )
        ) {
          return [true];
        } else {
          return [false];
        }
      }
      //end
    }
  }

  return [true];
}

function nationalDays(
  date,
  method_type,
  specific_location,
  numberofspecialproduct,
  special_collection_date
) {
  if (method_type) {
    if (method_type == "pickup") {
      var obj = ebzapiets;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );
    } else if ((method_name = "delivery")) {
      var obj = ebzapiets_delivery;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );
    }

    if (selected_location["blackout"]) {
      disabledDays = selected_location["blackout"];
      if (numberofspecialproduct) {
        disabledDays = "";
      }
      if (!numberofspecialproduct) {
        //var special_collection_date =special_collection_date.split(",");
        //disabledDays = disabledDays.concat(special_collection_date);
      }

      var m = date.getMonth(),
        d = date.getDate(),
        y = date.getFullYear();
      for (i = 0; i < disabledDays.length; i++) {
        if ($.inArray(y + "-" + (m + 1) + "-" + d, disabledDays) != -1) {
          return false;
        }
      }

      if (!disabledDays) {
        //var push=new Date(myday);
        var special_collection_date = special_collection_date.split(",");
        var sDate =
          date.getDate().toString() +
          "/" +
          (date.getMonth() + 1).toString() +
          "/" +
          date.getFullYear().toString();

        if (
          $.inArray(y + "-" + (m + 1) + "-" + d, special_collection_date) != -1
        ) {
          return true;
        } else {
          return false;
        }
      }
    }
  }
  return true;
}

// function show_storepickups() {
//   var obj = ebzapiets;
//   var storepick_data = jQuery.parseJSON(obj);
//   var show_storepick = false;
//   var single_data;
//   var store_html = '<div class="roses_shipping">';
//   var first_iteration = true;
//   for (single_data in storepick_data) {
//     var all_data = storepick_data[single_data];
//     if (all_data.enable_location) {
//       if (all_data.offset) {
//         show_storepick = true;
//         if (first_iteration) {
//           var status = "";
//           var checked = "checked";
//           first_iteration = false;
//         } else {
//           var status = "";
//           var checked = "";
//         }
//         store_html +=
//           '<div class="roses_ship_method"><input type="radio" ' +
//           checked +
//           ' name="method_pickup" value="' +
//           single_data +
//           '"' +
//           status +
//           ' id="' +
//           single_data +
//           '"/><label class="location_specs" for="' +
//           single_data +
//           '">' +
//           all_data.location_name +
//           ", " +
//           all_data.address_one +
//           " " +
//           all_data.city +
//           " " +
//           all_data.postal_code +
//           '</label><span class="ie_pick">' +
//           all_data.location_name +
//           ", " +
//           all_data.address_one +
//           " " +
//           all_data.city +
//           " " +
//           all_data.postal_code +
//           "</span></div>";
//       }
//     }
//   }
//   store_html += "</div>";
//   var obj = ebzapiets_delivery;
//   var selected_location = jQuery.parseJSON(obj);

//   var enable_delivery = false;
//   for (var i in selected_location) {
//     if (selected_location[i].enable_delivery) {
//       enable_delivery = true;
//       break;
//     }
//   }

//   if (!enable_delivery) {
//     jQuery(".shipping_option .delivers").hide();
//   }
//   if (show_storepick) {
//     jQuery(".location_single").html(store_html);
//   } else {
//     jQuery(".shipping_option .storepickups").hide();
//     jQuery(".shipping_option").hide();
//   }
// }

function update_pickup(details) {
  var obj = ebzapiets;
  var storepick_data = jQuery.parseJSON(obj);
  var location = storepick_data[details];
  var data =
    '<input type="hidden" name="attributes[Location-Name]" value="' +
    location.location_name +
    '" /><input type="hidden" name="attributes[Address]" value="' +
    location.address_one +
    '" /><input type="hidden" name="attributes[City]" value="' +
    location.city +
    '" /><input type="hidden" name="attributes[Location-Postal-Code]" value="' +
    location.postal_code +
    '" /><input type="hidden" name="attributes[Postal-Code]" value=""/><input type="hidden" name="attributes[date]" value="" /><input type="hidden" name="attributes[timeslot]" value="" />';
  jQuery(".hidden_fields").html(data);
}

function update_empty_pickup() {
  var data =
    '<input type="hidden" name="attributes[Location-Name]" value="" /><input type="hidden" name="attributes[Address]" value="" /><input type="hidden" name="attributes[City]" value="" /><input type="hidden" name="attributes[Location-Postal-Code]" value="" /><input type="hidden" name="attributes[Pickup-Date]" value="" /><input type="hidden" name="attributes[Pickup-Time]" value="" />';
  jQuery(".hidden_fields").html(data);
}

function getDescendantProp(obj, desc) {
  var arr = desc.split(".");
  while (arr.length && (obj = obj[arr.shift()]));
  return obj;
}

function offsetdata(method_name, specific_location) {
  if (method_name) {
    if (method_name == "pickup") {
      var obj = ebzapiets;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );
    } else if (method_name == "delivery") {
      var obj = ebzapiets_delivery;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );
    }

    var offset_days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    var d = new Date(get_timezone_date("+8"));
    var n = d.getDay();
    var current_hour = d.getHours();
    var current_minutes = d.getMinutes();
    day_name = offset_days[n];

    var selected_offset = selected_location.offset;
    var selected_offset_day = getDescendantProp(selected_offset, day_name);

    if (selected_offset_day.before) {
      var push_day = selected_offset_day.before;
    } else {
      var push_day = 0;
    }

    if (selected_offset_day.enable_breakpoint) {
      var break_point_val = selected_offset_day.breakpoint;
      var current_full_time = current_hour * 100 + (current_minutes / 60) * 100;
      if (current_full_time >= break_point_val) {
        var push_day = selected_offset_day.after;
      }
    }
    if (push_day == 0) {
      if (method_name == "pickup") {
        var selected_days = selected_location.days;
        var selected_time_day = getDescendantProp(selected_days, day_name);
        var last_hour = parseInt(selected_time_day.end / 100);

        if (parseInt(current_hour) >= last_hour) {
          push_day = 1;
        }
      } else if (method_name == "delivery") {
        var selected_days = selected_location.slot;
        var selected_time_day = getDescendantProp(selected_days, day_name);
        var found = false;
        //console.log('selected_time_day: ', selected_time_day);
        if (selected_time_day) {
          // kaustuv
          for (index_off in selected_time_day) {
            var end_time = selected_time_day[index_off].end;
            var cutoff_time = selected_time_day[index_off].cutoff_time;

            var end_time_HM = timeToHM(end_time);
            var cutoff_time_HM = timeToHM(cutoff_time);
            var till_HM = cutoff_time == "" ? end_time_HM : cutoff_time_HM;
            //console.log(current_time_HM, end_time_HM, cutoff_time_HM);

            if (current_time_HM < till_HM) {
              found = true;
            }
          }
        } else {
          found = true;
        }
        if (!found) {
          push_day = 1;
        }
      }
    }
    return push_day;
  }
}

function timeToHM(time) {
  if (time == "") {
    return null;
  }
  var arr = time.split(":");
  var hm = parseInt(arr[0]) * 100 + parseInt(arr[1]);
  return hm;
}

function addDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

function subtractDays(date, days) {
  var result = new Date(date);
  result.setDate(result.getDate() - days);
  return result;
}

function populate_date(date, method_type, specific_location) {
  if (method_type) {
    var d = new Date(date);
    var select_date = d.toDateString();
    var n = d.getDay();
    var days = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];
    var day_name = days[n];
    var text = "";

    var today_d = new Date(current_time);
    var today_d_string = today_d.toDateString();
    var current_hour = parseInt(today_d.getHours());

    if (method_type == "pickup") {
      var obj = ebzapiets;
      var storepick_data = jQuery.parseJSON(obj);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );

      var selected_offset = selected_location.days;
      var today_d = new Date(get_timezone_date("+8"));
      var today_d_string = today_d.toDateString();
      var current_hour = parseInt(today_d.getHours());

      if (selected_offset.enable_pickuptime) {
        var selected_offset_day = getDescendantProp(selected_offset, day_name);

        if (!selected_offset_day.disable) {
          var first_hour = parseInt(selected_offset_day.start);
          var last_hour = parseInt(selected_offset_day.end);

          var text =
            "<select id='popup_time'><option value=''>Choose Time</option>";
          var count = parseInt(first_hour);

          if (select_date == today_d_string) {
            if (current_hour <= count / 100) {
              if (count % 100 == 0) {
                val = parseInt(count / 100) + ":00";
                text += '<option value="' + val + '">' + val + "</option>";
                count += 100;
              } else {
                val = parseInt(count / 100) + ":30";
                text += '<option value="' + val + '">' + val + "</option>";
                count += 50;
              }
            } else {
              if (count % 100 != 0) {
                count += 50;
              }
            }
          } else {
            if (count % 100 == 0) {
              val = parseInt(count / 100) + ":00";
              text += '<option value="' + val + '">' + val + "</option>";
              count += 100;
            } else {
              val = parseInt(count / 100) + ":30";
              text += '<option value="' + val + '">' + val + "</option>";
              count += 50;
            }
          }

          while (count <= last_hour) {
            if (select_date == today_d_string) {
              if (current_hour >= count / 100) {
                count += 100;
                continue;
              }
            }
            val = parseInt(count / 100) + ":00";
            text += '<option value="' + val + '">' + val + "</option>";
            count += 100;
          }

          if (select_date == today_d_string) {
            if (last_hour % 100 != 0 && first_hour != last_hour) {
              hour = parseInt(last_hour / 100);
              if (current_hour <= hour) {
                vals = hour + ":30";
                text += '<option value="' + vals + '">' + vals + "</option>";
              }
            }
          } else {
            if (last_hour % 100 != 0 && first_hour != last_hour) {
              hour = parseInt(last_hour / 100);
              vals = hour + ":30";
              text += '<option value="' + vals + '">' + vals + "</option>";
            }
          }
          text += '</select><div class="error_popuptime"></div>';
        }
      } else {
        var text = "";
      }
    } else if (method_type == "delivery") {
      var obj = ebzapiets_delivery;
      var storepick_data = jQuery.parseJSON(obj);
      //console.log(storepick_data);
      var selected_location = getDescendantProp(
        storepick_data,
        specific_location
      );

      var selected_offset = selected_location.slot;
      var selected_offset_day = getDescendantProp(selected_offset, day_name);

      if (selected_offset.enable_deliverytime) {
        if (selected_offset_day) {
          var text =
            "<select id='delivery_time'><option value=''>Choose Time</option>";
          for (index_off in selected_offset_day) {
            var start_time = selected_offset_day[index_off].start;
            var end_time = selected_offset_day[index_off].end;
            var cutoff_days = parseInt(
              selected_offset_day[index_off].cutoff_days
            );
            var cutoff_time = selected_offset_day[index_off].cutoff_time;
            //console.log(selected_offset_day[index_off]);

            var end_time_HM = timeToHM(end_time);
            var cutoff_time_HM = timeToHM(cutoff_time);
            //console.log(current_time_HM, start_time_HM, end_time_HM, cutoff_time_HM);

            if (select_date == today_d_string) {
              var till_HM = cutoff_time == "" ? end_time_HM : cutoff_time_HM;
              if (cutoff_days > 0 || current_time_HM >= till_HM) {
                continue;
              }
            } else if (cutoff_time != "" && cutoff_days == 1) {
              var compare_date = addDays(current_time, cutoff_days);
              var compare_d_string = compare_date.toDateString();
              //console.log(cutoff_days, 'selected_date: ' + select_date, 'compare_d_string: ' + compare_d_string, 'cutoff_time_HM: ' + cutoff_time_HM);
              if (
                select_date == compare_d_string &&
                current_time_HM >= cutoff_time_HM
              ) {
                continue;
              }
            }

            time_range =
              convertTo12HourFormat(start_time) +
              " - " +
              convertTo12HourFormat(end_time);
            text +=
              '<option value="' +
              time_range +
              '">Between ' +
              time_range +
              "</option>";
          }
          text += '</select><div class="error_popuptime"></div>';
        }
      } else {
        text = "";
      }
    }
    jQuery("#time_of_day").html(text);
    //jQuery('#checkout_time').html(text);
  }
}

function get_timezone_date(offset) {
  var obj_current = current_time;
  return obj_current;
}

function disable_keypress() {
  $("form.cart")
    .find("input")
    .keypress(function (e) {
      if (e.which == 13) {
        // Enter key = keycode 13
        $(this).next().focus(); //Use whatever selector necessary to focus the 'next' input
        $(".choose_date input#postal_code").blur();
        return false;
      }
    });
}

function dynamic_option(
  method_type,
  ebzapiets_delivery,
  add_postalcode,
  numberofspecialproduct,
  special_collection_date,
  SKUlist
) {
  var sptext =
    "Unfortunately only " +
    '<a style="color: red;" href="https://rosesonly.com.sg/collections/valentines-roses" target="_blank">' +
    " Valentine's day collection" +
    "</a> is available for delivery during 11th, 12th, 13th, 14th and 15th Feb";
  jQuery(".datetimewrapper").show();

  if (method_type == "pickup") {
    jQuery(".datetime-title").html(
      "Please select a date for pickup. <br>Note: Your ID and Credit Card used must be presented for collection."
    );
  } else {
    jQuery(".datetime-title").html(
      "Please select date and we will load available time."
    );
  }

  $("input[name='attributes[Type]']").val(method_type);

  var method_type = "delivery";
  var obj = ebzapiets_delivery;
  var selected_location = jQuery.parseJSON(obj);
  console.log(selected_location);

  //get delivery group for skus in
  for (var i in selected_location) {
    if (selected_location[i].enable_delivery) {
      if (selected_location[i].product_sku) {
        var product_sku = selected_location[i].product_sku;
        var product_sku_list = product_sku.split(",");
        for (var sku in SKUlist) {
          for (var count in product_sku_list) {
            if (SKUlist[sku].trim() == product_sku_list[count].trim()) {
              delivery_grp = i;
            }
          }
        }
      }
    }
  }
  if (!delivery_grp) {
    for (var i in selected_location) {
      if (
        selected_location[i].enable_delivery &&
        !selected_location[i].product_sku
      ) {
        delivery_grp = i;
        break;
      }
    }
  }

  console.log(delivery_grp);
  if (delivery_grp) {
    var push_d = offsetdata(method_type, delivery_grp);
    if (!push_d) {
      push_d = 0;
    }
    var dateToday = new Date(get_timezone_date("+8"));

    var myday = dateToday.setDate(dateToday.getDate() + parseInt(push_d));
    var push = new Date(myday);
    if (numberofspecialproduct) {
      var push = special_date_init(special_collection_date, push_d);
    }
    jQuery(".choose_date .datepickerWrapper").html(
      '<span class="formatteddate"></span><input type="hidden" id="date_picker" placeholder="Please Choose Date above." required readonly /><div class="error_datepicker"></div>'
    );
    jQuery("#datepicker").datepicker({
      dateFormat: "yy-mm-dd",
      minDate: push,
      firstDay: 1,
      showOtherMonths: true,
      selectOtherMonths: false,
      beforeShowDay: function (date) {
        return noWeekendsOrHolidays(
          date,
          "delivery",
          delivery_grp,
          numberofspecialproduct,
          special_collection_date
        );
      },
      onSelect: function (dateText, instobj) {
        console.log("sfds");
        var selectedDate = $(this).val();
        var msg_for_special_date = specialdatemessage(
          special_collection_date,
          numberofspecialproduct,
          selectedDate
        );
        if (msg_for_special_date) {
          jQuery("error_datepicker").html("");
          jQuery('input[name="checkout[attributes][date]"]').val("");
          jQuery("#time_of_day").hide();
          jQuery("span.formatteddate").html(sptext).css({
            color: "#a81c20",
            "font-style": "bold",
            "font-size": "12px",
          });
        } else {
          jQuery(this).data("datepicker").inline = true;
          jQuery("#date_picker").val(dateText);
          cltr = dateFormat(dateText, "dddd dS mmm yyyy");
          jQuery("span.formatteddate").html(cltr);
          jQuery(".error_datepicker").html("");
          jQuery("#time_of_day").show();
          populate_date(dateText, "delivery", delivery_grp);
          $("#time_of_day select").niceSelect();
        }
        //$('#checkout_date').val(selectedDate)
      },
    });
  }
  //break;

  setTimeout(function () {
    $(document)
      .find("td.ui-datepicker-current-day")
      .removeClass("ui-datepicker-current-day");
  }, 100);
}

function special_date_init(special_collection_date, push_d) {
  var special_collection_date = special_collection_date.split(",");
  var dateToday = new Date(get_timezone_date("+8"));
  var dateToday = dateToday.setDate(dateToday.getDate() + parseInt(push_d));
  var dateToday = new Date(dateToday);
  for (var i = 0; i < special_collection_date.length; i++) {
    //var dateSpecial = new Date(special_collection_date[i]);
    var dateSpecial = formatteddate(special_collection_date[i]);
    dateSpecial = dateSpecial.toString();
    dateSpecial = dateSpecial.substring(0, 15);
    var gmt = dateToday.toString().substring(15, 33);
    var dateSpecial_gmt = dateSpecial.concat(gmt);
    if (
      +new Date(dateSpecial_gmt) > +new Date(dateToday) ||
      +new Date(dateSpecial_gmt) == +new Date(dateToday)
    ) {
      var push = new Date(dateSpecial_gmt);
      return push;
      break;
    }
  }
}

function formatteddate(push) {
  var d = new Date(push.replace(/-/g, "/"));
  var curr_date = d.getDate();
  var curr_month = d.getMonth();
  curr_month++;
  var curr_year = d.getFullYear();
  var push = curr_year + "/" + curr_month + "/" + curr_date;
  return push;
}

function specialdatemessage(
  special_collection_date,
  mixedcollections,
  selectedDate
) {
  console.log({ special_collection_date, mixedcollections, selectedDate });
  if (!mixedcollections) {
    var special_collection_date = special_collection_date.split(",");
    for (var i = 0; i < special_collection_date.length; i++) {
      var special_date = formatteddate(special_collection_date[i]);
      var special_date = dateFormat(special_date, "yyyy/mm/dd");
      if (special_date == selectedDate) {
        return true;
        break;
      }
    }
  } else {
    return false;
  }
}

function convertTo12HourFormat(timeString) {
  var timeArray = timeString.split(":");
  var hours = parseInt(timeArray[0]);
  var minutes = parseInt(timeArray[1]);
  var period = hours < 12 ? "am" : "pm";
  hours = hours % 12 || 12;
  hours = hours < 10 ? "0" + hours : hours;
  var formattedTime =
    hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + " " + period;

  return formattedTime;
}

$(document).on("click", "div.pop-up .close, div.pop-up .overlay", function (e) {
  $(this).parent("div.pop-up").fadeOut().removeClass("is-open");
  $("body").removeClass("disable-scroll");
});

$(document).on("click", "#calendar_popup", function (e) {
  console.log("Test1");
  e.preventDefault();
  var date = $("#date_picker").val();
  var dateText = jQuery("span.formatteddate").text();
  var time = jQuery("#time_of_day select#delivery_time").val();
  var type = $("input[name='attributes[Type]']").val();
  var location_detail = $(
    '.roses_shipping input[name="method_pickup"]:checked'
  ).val();

  if (date && time) {
    console.log("Test");
    update_datetime_attributes(type);
    $("#checkout_date").val(date);
    $("#checkout_time").val(time);

    if (type == "delivery") {
      $("#open_delivery_calendar").val(dateText + ", " + time);
      $("#open_pickup_calendar").val("");
      update_empty_pickup();
    } else {
      $("#open_pickup_calendar").val(dateText + ", " + time);
      $("#open_delivery_calendar").val("");
      update_pickup(location_detail);
    }

    $(".pop-up").fadeOut().removeClass("is-open");
    $("body").removeClass("disable-scroll");
    //$(".cart__checkout-button, .cart__dynamic-checkout-buttons").removeClass("hide");
    $(".cart__checkout-button").prop("disabled", false);
    $(".tab_based_content").removeAttr("style");
  } else {
    $(".error_datepicker").html("Please choose both date and time");
  }
});

function update_datetime_attributes(type) {
  if (type == "delivery") {
    $("#checkout_date").attr("name", "attributes[date]");
    $("#checkout_time").attr("name", "attributes[timeslot]");
  } else {
    $("#checkout_date").attr("name", "attributes[Pickup-Date]");
    $("#checkout_time").attr("name", "attributes[Pickup-Time]");
  }
}

$(document).on("click", ".open-calendar", function (e) {
  var SKUlist = productSKU.split(',');
  if ($(this).hasClass("delivery")) {
    var method_type = "delivery";
  } else {
    var method_type = "pickup";
  }
  dynamic_option(
    method_type,
    ebzapiets_delivery,
    add_postalcode,
    numberofspecialproduct,
    special_collection_date,
    SKUlist
  );
  $("#dates").fadeIn().addClass("is-open");
  $("body").addClass("disable-scroll show-popup");
});
